import get from 'lodash/get';

const getBreadcrumbTrail = (companyName, page) => {
  if (!page) {
    return companyName;
  }

  const {
    title,
    breadcrumbTrail,
  } = page;

  const breadcrumbName = get(breadcrumbTrail, 'name', title);
  const ancestorPages = get(breadcrumbTrail, 'ancestorPages', []);
  const result = [
    companyName,
    ...ancestorPages.map(ancestor => ancestor.breadcrumbTrail.name),
    breadcrumbName,
  ];

  return result.join(' / ');
};

export default getBreadcrumbTrail;
